import React from "react";
import { Helmet } from "react-helmet-async";

const IVFTreatmentAmbala = () => {
  return (
    <>
      <Helmet>
        <title>IVF Treatment in Ambala | Amaanat IVF Clinic</title>
        <meta name="description" content="Advanced IVF treatment in Ambala." />
        <link rel="canonical" href="https://amaanativf.com/ivf-treatment-in-ambala" />
      </Helmet>

      <div className="container py-5">
        <h1>IVF Treatment in Ambala</h1>
        <p>Amaanat IVF Clinic provides advanced fertility care in Ambala.</p>

        <h2>Why Choose Us?</h2>
        <ul>
          <li>Experienced Fertility Specialists</li>
          <li>Advanced IVF Laboratory</li>
          <li>Personalized Treatment Plans</li>
          <li>Affordable Care</li>
        </ul>
      </div>
    </>
  );
};

export default IVFTreatmentAmbala;
